/* tslint:disable */
/* eslint-disable */
/**
 * Registration App Tier Micro Service APIs
 * Registration App Tier Micro Service APIs
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoAppDocument
 */
export interface CoAppDocument {
    /**
     * 
     * @type {string}
     * @memberof CoAppDocument
     */
    documentType?: CoAppDocumentDocumentTypeEnum;
    /**
     * base64 encoded image data for validation or uploading.
     * @type {string}
     * @memberof CoAppDocument
     */
    documentData?: string;
    /**
     * the mime type of the documentData
     * @type {string}
     * @memberof CoAppDocument
     */
    documentMimeType?: string;
    /**
     * document data tier unique id for reference. We will need to use to convert it to base64 data.
     * @type {string}
     * @memberof CoAppDocument
     */
    documentId?: string;
}


/**
 * @export
 */
export const CoAppDocumentDocumentTypeEnum = {
    MarriageCertificate: 'MARRIAGE_CERTIFICATE'
} as const;
export type CoAppDocumentDocumentTypeEnum = typeof CoAppDocumentDocumentTypeEnum[keyof typeof CoAppDocumentDocumentTypeEnum];


/**
 * Check if a given object implements the CoAppDocument interface.
 */
export function instanceOfCoAppDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CoAppDocumentFromJSON(json: any): CoAppDocument {
    return CoAppDocumentFromJSONTyped(json, false);
}

export function CoAppDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoAppDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentType': !exists(json, 'documentType') ? undefined : json['documentType'],
        'documentData': !exists(json, 'documentData') ? undefined : json['documentData'],
        'documentMimeType': !exists(json, 'documentMimeType') ? undefined : json['documentMimeType'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
    };
}

export function CoAppDocumentToJSON(value?: CoAppDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentType': value.documentType,
        'documentData': value.documentData,
        'documentMimeType': value.documentMimeType,
        'documentId': value.documentId,
    };
}

